// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as InlineText from "../../resources/layout-and-structure/InlineText.res.js";
import * as LegacyIcon from "../../resources/images-and-icons/LegacyIcon.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Stdlib_Int from "@rescript/runtime/lib/es6/Stdlib_Int.js";
import * as KbdClipboard from "../../resources/typography/KbdClipboard.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as CatalogVariant from "./CatalogVariant.res.js";
import * as JsxRuntime from "react/jsx-runtime";

let make = React.memo(props => {
  let children = props.children;
  if (children !== undefined) {
    return JsxRuntime.jsxs(InlineText.make, {
      children: [
        JsxRuntime.jsx(TextStyle.make, {
          children: props.label,
          variation: "normal"
        }),
        JsxRuntime.jsx(TextStyle.make, {
          children: " "
        }),
        JsxRuntime.jsx(TextStyle.make, {
          children: children
        })
      ]
    });
  } else {
    return null;
  }
});

let InfoTextLine = {
  make: make
};

let make$1 = React.memo(props => {
  let __displayVariantId = props.displayVariantId;
  let __displayShopName = props.displayShopName;
  let variant = props.variant;
  let displayShopName = __displayShopName !== undefined ? __displayShopName : true;
  let displayVariantId = __displayVariantId !== undefined ? __displayVariantId : false;
  if (variant === undefined) {
    return null;
  }
  let tmp;
  let exit = 0;
  if (variant.ean13 !== undefined || variant.stockKeepingUnit !== undefined || variant.priceLookUpCode !== undefined || variant.internalCode !== undefined) {
    exit = 1;
  } else {
    tmp = null;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(make, {
          children: variant.ean13,
          label: I18n.t("Bar code")
        }),
        JsxRuntime.jsx(make, {
          children: variant.stockKeepingUnit,
          label: "SKU"
        }),
        JsxRuntime.jsx(make, {
          children: Stdlib_Option.map(variant.priceLookUpCode, plu => plu.toString()),
          label: "PLU"
        }),
        JsxRuntime.jsx(make, {
          children: variant.internalCode,
          label: I18n.t("Internal code")
        })
      ]
    });
  }
  let match = variant.id;
  let tmp$1 = match === "" || !displayVariantId ? null : JsxRuntime.jsx(KbdClipboard.make, {
      label: I18n.t("Copy ID"),
      value: match
    });
  return JsxRuntime.jsxs(Stack.make, {
    children: [
      JsxRuntime.jsxs(Stack.make, {
        children: [
          displayShopName ? JsxRuntime.jsx(Box.make, {
              children: JsxRuntime.jsx(TextStyle.make, {
                children: I18n.t("From catalog of") + " " + variant.shopName,
                variation: "normal",
                size: "xxsmall"
              }),
              spaceBottom: "xsmall"
            }) : null,
          JsxRuntime.jsx(TextStyle.make, {
            children: variant.name,
            weight: "strong"
          }),
          JsxRuntime.jsx(make, {
            children: variant.formattedCapacity,
            label: I18n.t("Capacity of")
          }),
          JsxRuntime.jsx(make, {
            children: Stdlib_Option.map(variant.year, year => {
              let value = Stdlib_Int.fromString(year, undefined);
              if (value !== undefined) {
                if (value === 1) {
                  return year + " " + I18n.t("year");
                } else if (value < 4) {
                  return year + " " + I18n.t(I18n.isPlural(value) ? "years" : "year");
                } else {
                  return year;
                }
              } else {
                return year;
              }
            }),
            label: I18n.t("Vintage")
          }),
          JsxRuntime.jsx(make, {
            children: variant.formattedAlcoholVolume,
            label: I18n.t("Alcohol volume of")
          })
        ]
      }),
      JsxRuntime.jsxs(Stack.make, {
        children: [
          tmp,
          tmp$1
        ]
      })
    ],
    space: "medium"
  });
});

let Content = {
  make: make$1
};

let make$2 = React.memo(props => {
  let variant = props.variant;
  if (variant !== undefined) {
    return JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("From catalog of") + " " + variant.shopName,
            variation: "normal",
            size: "xxsmall"
          }),
          spaceBottom: "xxsmall"
        }),
        JsxRuntime.jsx(TextStyle.make, {
          children: variant.name,
          weight: "strong"
        })
      ],
      space: "xsmall"
    });
  } else {
    return null;
  }
});

let PreviewContent = {
  make: make$2
};

let make$3 = React.memo(props => {
  let collapsed = props.collapsed;
  let match = Hover.use(undefined, undefined, undefined);
  return JsxRuntime.jsxs(Stack.make, {
    children: [
      props.children,
      JsxRuntime.jsx(Touchable.make, {
        children: JsxRuntime.jsxs(Inline.make, {
          children: [
            JsxRuntime.jsx(LegacyIcon.make, {
              name: collapsed ? "arrow_down_light" : "arrow_up_light"
            }),
            JsxRuntime.jsx(Title.make, {
              children: I18n.t(collapsed ? "Show more" : "Collapse"),
              level: 5,
              weight: "medium",
              color: match[1] ? "#797885" : undefined
            })
          ]
        }),
        onPress: props.onPress,
        ref: match[0]
      })
    ],
    space: "normal"
  });
});

let ShowMoreWrapper = {
  make: make$3
};

function CatalogVariantInformationCard(props) {
  let shopsVariant = props.shopsVariant;
  let match = React.useState(() => false);
  let setShowMore = match[1];
  let showMore = match[0];
  let scope = Auth.useScope();
  let match$1 = Navigation.useUrl();
  let variantDiffering = React.useMemo(() => CatalogVariant.MultiShops.isReferenceDiffering(shopsVariant, scope, (a, b) => {
    if (a.name === b.name && a.formattedCapacity === b.formattedCapacity && a.year === b.year && a.formattedAlcoholVolume === b.formattedAlcoholVolume && a.ean13 === b.ean13 && a.stockKeepingUnit === b.stockKeepingUnit && a.priceLookUpCode === b.priceLookUpCode) {
      return a.internalCode === b.internalCode;
    } else {
      return false;
    }
  }), [
    scope,
    shopsVariant
  ]);
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [
        JsxRuntime.jsx(make$1, {
          variant: shopsVariant[0],
          displayShopName: variantDiffering,
          displayVariantId: shopsVariant.length <= 1
        }),
        variantDiffering ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx(make$3, {
                children: showMore ? JsxRuntime.jsx(Stack.make, {
                    children: shopsVariant.slice(1).map(variant => JsxRuntime.jsx(make$1, {
                      variant: variant,
                      displayVariantId: shopsVariant.length <= 1
                    })),
                    space: "normal"
                  }) : JsxRuntime.jsx(make$2, {
                    variant: shopsVariant[1]
                  }),
                collapsed: !showMore,
                onPress: param => setShowMore(state => !state)
              }),
              showMore ? null : JsxRuntime.jsx(Banner.make, {
                  textStatus: {
                    TAG: "Warning",
                    _0: I18n.t("Beware, some information differs among the catalogs of the shops.")
                  },
                  compact: true
                })
            ]
          }) : null
      ],
      space: "large"
    }),
    title: I18n.t("Variant's information"),
    action: {
      icon: "legacy_edit",
      title: I18n.t("Edit variant"),
      href: match$1.pathname + "/edit"
    }
  });
}

let make$4 = React.memo(CatalogVariantInformationCard);

let Config;

export {
  Config,
  InfoTextLine,
  Content,
  PreviewContent,
  ShowMoreWrapper,
  make$4 as make,
}
/* make Not a pure module */
